import { useEffect, useState } from 'react'
import { fetchWrapper } from './apiHandlers'
import { userContext } from '../usercontext'

// The conversation this browser TAB is in. sessionStorage on purpose: closing the tab ends a guest's chat
// (like other AI assistants), while a refresh keeps it. Guest chats are also deleted by the server after
// 24 hours idle; signed-in chats are kept until the person deletes them.
const KEY = 'miamigo_shop_chat'

export const activeChat = {
  get(): string {
    try { return sessionStorage.getItem(KEY) || '' } catch (e) { return '' }
  },
  set(cid: string) {
    try { cid ? sessionStorage.setItem(KEY, cid) : sessionStorage.removeItem(KEY) } catch (e) {}
  },
}

export interface ChatSummary {
  cid: string
  title: string
  updatedat: string
  messagecount: number
}

export const chatApi = {
  list: async (): Promise<ChatSummary[]> => {
    const r: any = await fetchWrapper.get('/api/directory/chats')
    return r.status === 200 ? r.chats : []
  },
  load: async (cid: string, lat?: number, lon?: number): Promise<any | null> => {
    const q = lat !== undefined && lon !== undefined ? `?lat=${lat}&lon=${lon}` : ''
    const r: any = await fetchWrapper.get(`/api/directory/chats/${cid}${q}`)
    return r.status === 200 ? r.chat : null
  },
  remove: (cid: string) => fetchWrapper.post(`/api/directory/chats/${cid}/delete`, {}),
  rename: (cid: string, title: string) => fetchWrapper.post(`/api/directory/chats/${cid}/rename`, { title }),
  removeAll: () => fetchWrapper.post('/api/directory/chats/deleteall', {}),
}

const isSignedIn = () => {
  const u: any = userContext.userValue
  return !!(u && u.token && u.status === 200)
}

export const useSignedIn = () => {
  const [signedIn, setsignedin] = useState(isSignedIn())
  useEffect(() => {
    const sub = userContext.user.subscribe(() => setsignedin(isSignedIn()))
    return () => sub.unsubscribe()
  }, [])
  return signedIn
}
